import React, { Fragment } from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';
import { getFirstImage } from 'lib/assets/assets_helpers';
import noimg from 'assets/img/noimg.gif';

const AssetFormGeneral = ({
  catalogs = {},
  errors = {},
  handleValueChange = () => {},
  isLoading = false,
  isSubmitted = false,
  t = () => {},
  values = {},
}) => {
  const renderFields = () => (
    <Fragment>
      <div className="col-sm-6 col-md-4 col-lg-6">
        <Form.FieldInput
          autoFocus={true}
          error={(isSubmitted && errors.number) || {}}
          name={'number'}
          label={t('assets.fields.number') + ' * '}
          handleChange={handleValueChange}
          t={t}
          value={values.number}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-6">
        <Form.FieldSelect
          error={(isSubmitted && errors._prefix) || {}}
          isLoading={isLoading}
          name={'prefix'}
          label={t('assets.fields.prefix')}
          handleChange={handleValueChange}
          t={t}
          value={values._prefix && values._prefix.id}
        >
          {catalogs.prefix &&
            catalogs.prefix
              .filter((element) => element != null)
              .map((element) => {
                if (!element || element.deleted || !element.active) return null;
                return (
                  <option value={element.id} key={element.id}>
                    {t(element.value)}
                  </option>
                );
              })}
        </Form.FieldSelect>
      </div>
    </Fragment>
  );

  const img = getFirstImage(values._files) || noimg;

  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.general')}</b>
        </h5>
        <br />
      </div>
      {values.id ? (
        <Fragment>
          <div className="col-sm-6 col-md-7 col-xl-8">
            <div className="row">{renderFields()}</div>
          </div>
          <div className="col-sm-6 col-md-5  col-xl-4 text-center mb-3">
            {img && img.url ? (
              <a href={img.url} target="__brank">
                <img src={img.url} style={{ maxWidth: '70%', maxHeight: '200px' }} />
              </a>
            ) : (
              <img src={img} style={{ width: '70%' }} />
            )}
          </div>
        </Fragment>
      ) : (
        renderFields()
      )}
    </div>
  );
};

export default translate()(AssetFormGeneral);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormDescription.js